import React from "react";
import { s } from "../styles";

const ITEMS: ReadonlyArray<[string, string]> = [
  ["14", "Employment income – Enter on line 10100. Revenus d'emploi – Inscrivez à la ligne 10100."],
  ["16", "Employee's CPP contributions (base plus first additional). Cotisations de l'employé au RPC."],
  ["16A", "Employee's second CPP contributions (CPP2). Deuxièmes cotisations de l'employé au RPC (RPC2)."],
  ["17", "Employee's QPP contributions. Cotisations de l'employé au RRQ."],
  ["17A", "Employee's second QPP contributions (QPP2). Deuxièmes cotisations de l'employé au RRQ (RRQ2)."],
  ["18", "Employee's EI premiums – canada.ca/line-31200. Cotisations de l'employé à l'AE."],
  ["20", "RPP contributions – canada.ca/line-20700. Cotisations à un RPA."],
  ["22", "Income tax deducted – Enter on line 43700. Impôt sur le revenu retenu – ligne 43700."],
  ["44", "Union dues – Enter on line 21200. Cotisations syndicales – ligne 21200."],
  ["45", "Employer-offered dental benefits. Prestations dentaires offertes par l'employeur."],
  ["46", "Charitable donations. Dons de bienfaisance."],
  ["52", "Pension adjustment – Enter on line 20600. Facteur d'équivalence – ligne 20600."],
  ["55", "Provincial parental insurance plan (PPIP). Régime provincial d'assurance parentale (RPAP)."],
  ["66", "Eligible retiring allowances – canada.ca/line-13000. Allocations de retraite admissibles."],
  ["67", "Non-eligible retiring allowances – canada.ca/line-13000. Allocations de retraite non admissibles."],
  ["77", "Workers' compensation benefits repaid to the employer – line 22900."],
  ["85", "Employee-paid premiums for private health services plans – canada.ca/line-33099."],
  ["87", "Emergency services volunteer exempt amount – canada.ca/line-10100."],
];

const CRA_ONLY: ReadonlyArray<[string, string]> = [
  ["30", "Board and lodging – Pension et logement"],
  ["31", "Special work site – Chantier particulier"],
  ["32", "Travel in a prescribed zone – Voyages dans une zone visée par règlement"],
  ["33", "Medical travel assistance – Aide pour les voyages pour soins médicaux"],
  ["34", "Personal use of employer's automobile – Usage personnel de l'automobile de l'employeur"],
  ["36", "Interest-free and low-interest loans – Prêts sans intérêt ou à faible intérêt"],
  ["38", "Security options benefits – Avantages liés aux options d'achat de titres"],
  ["40", "Other taxable allowances and benefits – Autres allocations et avantages imposables"],
  ["86", "Security options election – Choix lié aux options d'achat de titres"],
];

export default function ReversePage() {
  return (
    <div style={s.rev}>
      <div style={s.revH}>
        Report these amounts on your tax return. / Veuillez déclarer ces montants dans votre déclaration de revenus.
      </div>
      <div style={s.revCols}>
        {ITEMS.map(([n, t]) => (
          <div key={n} style={s.revBox}>
            <b>{n}</b> {t}
          </div>
        ))}
      </div>
      <div style={s.revGrp}>
        <b>
          Do not report these amounts on your tax return. For Canada Revenue
          Agency use only.
        </b>{" "}
        (Amounts in boxes 30, 32, 34, 36, 38, 40, 57, 58, 59, 60, 86 and 90 are already included in box 14.)
        <br />
        <b>
          Ne déclarez pas ces montants dans votre déclaration de revenus. À
          l'usage de l'Agence du revenu du Canada seulement.
        </b>
        <div style={{ ...s.revCols, marginTop: 8 }}>
          {CRA_ONLY.map(([n, t]) => (
            <div key={n} style={s.revBox}>
              <b>{n}</b> {t}
            </div>
          ))}
        </div>
      </div>
      <div style={s.revFoot}>
        <span>
          <b>T4 (25)</b>
        </span>
        <span>
          Privacy Act, CRA PPU 005 and CRA PPU 047 – Loi sur la protection des renseignements personnels, ARC PPU 005 et ARC PPU 047
        </span>
      </div>
    </div>
  );
}